import React from 'react';
import { Outlet } from 'react-router-dom';
import { ClientAuthProvider } from '../../contexts/ClientAuthContext';
import { ClientThemeProvider } from '../../contexts/ClientThemeContext';

const ClientPortalShell = () => (
  <ClientThemeProvider>
    <ClientAuthProvider>
      <Outlet />
    </ClientAuthProvider>
  </ClientThemeProvider>
);

export default ClientPortalShell;
